module.exports = __webpack_public_path__ + "static/leaf-6525da688a2adb2a5aa3b986e68afcb3.jpg";